import { SystemMaintenanceEventSearchRequestQuery } from '@lio/api-types';

export const getSystemMaintenanceParamsQuery = (requestParams?: SystemMaintenanceEventSearchRequestQuery) => {
  if (!requestParams) return '';
  const { startAfter, endBefore, activeAt, endAfter, pageLimit, pageOffset } = requestParams;
  const query = new URLSearchParams();

  if (startAfter) {
    query.append('startAfter', new Date(startAfter).toISOString());
  }
  if (endBefore) {
    if (endBefore === 'now') {
      query.append('endBefore', new Date().toISOString());
    } else query.append('endBefore', new Date(endBefore).toISOString());
  }
  if (activeAt) {
    if (activeAt === 'now') {
      query.append('activeAt', new Date().toISOString());
    } else query.append('activeAt', activeAt);
  }
  if (endAfter) {
    if (endAfter === 'now') {
      query.append('endAfter', new Date().toISOString());
    } else query.append('endAfter', endAfter);
  }
  if (pageLimit) {
    query.append('pageLimit', pageLimit.toString());
  }
  if (pageOffset) {
    query.append('pageOffset', pageOffset.toString());
  }
  return query.toString();
};
